import { render } from "./QueueList.vue?vue&type=template&id=c57cb99e&scoped=true&ts=true"
import script from "./QueueList.vue?vue&type=script&lang=ts"
export * from "./QueueList.vue?vue&type=script&lang=ts"

import "./QueueList.vue?vue&type=style&index=0&id=c57cb99e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57cb99e"]])

export default __exports__